import PropTypes from 'prop-types';

export const DimensionType = {
  // using lowercase strings because there are already several usages of the lowercase version
  Length: 'length',
  Width: 'width',
  Height: 'height',
};

export const DimensionTypePropType = PropTypes.oneOf([DimensionType.Length, DimensionType.Width, DimensionType.Height]);
